module.exports = __webpack_public_path__ + "img/邀请好友@2x.70786e6b.png";